import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const auditlogsRoutes: RouteObject[] = [
  {
    path: ROUTES.AUDITLOGS.LIST,
    element: (
      <PrivateRoute>
        <Pages.Auditlogs />
      </PrivateRoute>
    ),
  },
]

export default auditlogsRoutes
